import { TrackingCategory } from '@bridebook/web/app-basic/lib/analytics/tracking-category';
import { TrackingEvent } from '@bridebook/web/app-basic/lib/analytics/tracking-event';
import { ThunkAction } from '@bridebook/web/app-basic/lib/types';

interface ClickedPayload {
  cta: string;
  clickedLocation: string;
  clickedSection: string;
}

export const clickedAnalytics: (payload: ClickedPayload) => ThunkAction<void> =
  (payload: ClickedPayload): ThunkAction<void> =>
  (_, __, { analyticsService }) =>
    analyticsService.getMethods(TrackingCategory.LoggedOut).track({
      event: TrackingEvent.Clicked,
      ...payload,
    });
